import React from 'react';
import { createUseStyles } from 'react-jss';

import './ChatBot.css';

function UserMessage({msg, isLastBotMessage}) {
const st=styles();
  return (
  
          <div
            key={msg.id}
            className={'user flex flex-row mb-1 align-items-end '+st.container }
          >
          
            <div className="message-text mr-5">
              <div>{msg.text||msg.inputValue}</div>
            </div>
            <span className="message-time">{msg.time}</span>
          </div>
  
  );
}

const styles = createUseStyles({
  container: {
    width:"100%"
  }
});

export default UserMessage;